import * as React from 'react';

const Attention16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m1 11.6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9 4H7l.5 5.4h1z",
    clipRule: "evenodd"
  }
));
Attention16.Size = 16;
Attention16.Title = "Attention";

export { Attention16 as default };
